import React from 'react';
import classnames from 'classnames';
import { PapiGallection } from '@wix/da-papi-types';
import SubfoldersIcon from '@wix/da-ds/pkg/Icons/24x24/Subfolders';
import FolderCoverInfo from '../../../FolderCoverInfo';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import GallectionCoverDumbo from '../../../GallectionCoverDumbo';
import folderCardStyles from '../../FolderCard.scss';

export type Props = {
  className?: string;
  folder: PapiGallection;
  hasSubfolders?: boolean;
  isCurrentUserOwner?: boolean;
  totalDeviationCount: number;
  width?: number;
  height?: number;
};

const FolderCardContent: React.FC<Props> = ({
  className,
  folder,
  folder: { subfolders, hasSubfolders: hasSubfoldersFromFolder = !!subfolders?.length, type },
  totalDeviationCount,
  hasSubfolders: hasSubfoldersOverride,
  isCurrentUserOwner,
  width,
  height,
}: Props) => {
  const hasSubfolders = hasSubfoldersOverride ?? hasSubfoldersFromFolder;

  if (!width || !height) {
    return null;
  }

  const isPremiumFolder = normalizePremiumFolderData(folder.premiumFolderData).isPremium;
  const isFolderThumbPublished = folder.thumb && folder.thumb.isPublished;
  const showBlurredThumbInfoToOwner =
    isCurrentUserOwner &&
    isPremiumFolder &&
    isFolderThumbPublished &&
    folder.thumb?.premiumFolderData;

  return (
    <div className={className}>
      {hasSubfolders && (
        <>
          <div className={folderCardStyles['subfolders-icon-underlay']} />
          <div className={folderCardStyles['top-right-icons']}>
            {hasSubfolders && (
              <SubfoldersIcon className={classnames(folderCardStyles['subfolders-icon'])} />
            )}
          </div>
        </>
      )}
      <GallectionCoverDumbo width={width} height={height} gallection={folder} />
      {showBlurredThumbInfoToOwner && (
        <>
          <div className={folderCardStyles['info-icon-underlay']} />
          <div className={folderCardStyles['top-right-icons']}>
            <FolderCoverInfo />
          </div>
        </>
      )}
    </div>
  );
};

export default FolderCardContent;
